import React from 'react';
import './header.css';
import logo from '../assets/logo512.png';
import logowhite from '../assets/logo-white.svg';
import menuWhite from '../assets/menu-white.svg';
import menuCloseWhite from '../assets/menu-close-white.svg';
import { Link } from 'react-router-dom';
import {LinkButton} from "./link-button";

class HeaderBlack extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sideMenuOpen: false
        }
    }


    isActive(headerItem) {
        return window.location.href.indexOf(headerItem) !== -1;
    }

    toggleSideMenu() {
        this.setState({sideMenuOpen: !this.state.sideMenuOpen});
    }

    render() {
        return (
            <>
                <div id='header-black'>
                    <div className='flex-row flex-vertical-center pointer logo-group'>
                        { window.innerWidth < 500 && <Link to="/"><img id="header-logo" alt="company-logo" src={logo} /></Link> }

                        { window.innerWidth >= 500 && <Link to="/"><img id="header-logo" alt="company-logo" src={logowhite}/></Link> }
                    </div>
                    <div className='menu'>
                        <Link to="/services"><div className={`menu-item b3 ${ this.isActive("services") ? "active-header-item": "" }`}>SERVICES</div></Link>
                        <Link to="/tehnologies"><div className={`menu-item b3 ${ this.isActive("tehnologies") ? "active-header-item": "" }`}>TEHNOLOGIES</div></Link>
                        <Link to="/case-studies"><div className={`menu-item b3 ${ this.isActive("case-studies") ? "active-header-item": "" }`}>PROJECTS</div></Link>
                        <Link to="/deep-dives"><div className={`menu-item b3 ${ this.isActive("deep-dives") ? "active-header-item": "" }`}>DEEP DIVES</div></Link>
                        {/*<Link to="/get-in-touch"><div id="get-in-touch" className={`primary-color b3  menu-item b3 ${ this.isActive("get-in-touch") ? "active-header-item": "" }`}>GET IN TOUCH</div></Link>*/}
                        <LinkButton to="/get-in-touch" text="GET IN TOUCH" className="primary-color get-in-touch-black white-color-txt" />
                    </div>
                </div>


                <div id='header-black-mobile'>
                    <Link className='place-center' to="/">
                        <img className='side-menu-logo' alt="company-logo" src={logowhite} />
                    </Link>

                    {!this.state.sideMenuOpen && <img src={menuWhite} className='side-menu-btn' onClick={() => this.toggleSideMenu()} alt="menu-btn" /> }
                    { this.state.sideMenuOpen && <img id='close-side-menu' alt='cross button' src={menuCloseWhite} onClick={() => this.toggleSideMenu()} /> }
                </div>

                { this.state.sideMenuOpen && <div className='side-menu-overlay' >
                    <div className='side-menu-content'>

                        <Link to="/services"><div className={`menu-item b3 white-color-txt ${ this.isActive("services") ? "active-header-item": "" }`}>SERVICES</div></Link>
                        <Link to="/tehnologies"><div className={`menu-item b3 white-color-txt ${ this.isActive("tehnologies") ? "active-header-item": "" }`}>TEHNOLOGIES</div></Link>
                        <Link to="/case-studies"><div className={`menu-item b3 white-color-txt ${ this.isActive("case-studies") ? "active-header-item": "" }`}>PROJECTS</div></Link>
                        <Link to="/deep-dives"><div className={`menu-item b3 white-color-txt ${ this.isActive("deep-dives") ? "active-header-item": "" }`}>DEEP DIVES</div></Link>

                        <LinkButton to="/get-in-touch" text="GET IN TOUCH" className="primary-color get-in-touch-black white-color-txt" />
                    </div>
                </div> }
            </>
        )
    }
}

export default HeaderBlack;